import angular from 'angular';

angular
    .module('rebroadcast')

    .controller('RebroadcastModalConfirmCtrl', [
        '$scope',
        '$uibModalInstance',
        'nbSelected',
        function($scope, $uibModalInstance, nbSelected) {
            $scope.nbSelected = nbSelected;
            $scope.ok = function() {
                if ($scope.form.$valid) {
                    $uibModalInstance.close($scope.motif);
                }
            };

            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);
